export default "__VITE_ASSET__i52iECYO__"